import type { VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { query } from '../../common/requests/base.query.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

import {
  PronunciationGraderParametersOutput,
  PronunciationGraderParametersOutputSchema,
} from '../types/pronunciation-grading-parameters.types.ts';

const GET_PRONUNCIATION_GRADER_PARAMETERS_QUERY = query({
  getPronunciationGraderParameters: [
    { input: input('input', 'GetPronunciationGraderParametersInput!') },
    {
      graderType: true,
      parameters: true,
    },
  ],
});

type GetPronunciationGraderParametersInputType = VariablesOf<typeof GET_PRONUNCIATION_GRADER_PARAMETERS_QUERY>['input'];
type GetPronunciationGraderParametersResponseType = PronunciationGraderParametersOutput;

export const getPronunciationGraderParametersQueryRequest = async (
  props: GetPronunciationGraderParametersInputType
): Promise<ResultType<GetPronunciationGraderParametersResponseType>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.query(
    GET_PRONUNCIATION_GRADER_PARAMETERS_QUERY,
    { input: props },
    ['getPronunciationGraderParameters'],
    { useAuth: true }
  );

  if (response?.getPronunciationGraderParameters) {
    return {
      success: true,
      data: PronunciationGraderParametersOutputSchema.parse({
        ...response.getPronunciationGraderParameters,
        parameters: JSON.parse(response.getPronunciationGraderParameters.parameters as string),
      }),
    };
  }

  return {
    success: false,
  };
};
